export const componentName = 'BizVehicleItem';
